import {getContrastRatio} from "@mui/material/styles";

const MIN_CONTRAST = 4.5;

const ratio = (foreground: string, background: string) => {
  try {
    return getContrastRatio(foreground, background);
  } catch {
    return 0;
  }
};

const readableColor = (background: string, preferred: string) => {
  if (ratio(preferred, background) >= MIN_CONTRAST) {
    return preferred;
  }
  const black = "#000000";
  const white = "#ffffff";
  return ratio(black, background) >= ratio(white, background) ? black : white;
};

const pickBackground = (foreground: string, candidates: string[]) =>
  candidates.find(color => ratio(foreground, color) >= MIN_CONTRAST) ??
  candidates[0];

export {MIN_CONTRAST, pickBackground, ratio, readableColor};
